import React from 'react';

import {and, any} from '@edna/utils';

import {PRIVATE_ROUTES} from 'src/containers/App/routes';
import {EPermission, ERoles, useGetCurrentUserQuery} from 'src/containers/User';

import {TPermissionProps} from './types';

const PermissionCheck = React.memo<TPermissionProps>(({href = '', children}) => {
  const {data: user} = useGetCurrentUserQuery();

  if (!user) {
    return <>{children(false)}</>;
  }

  const routePermissions = PRIVATE_ROUTES[href]?.permissions ?? any();

  const hasPermission =
    and<ERoles>('ROLE_ACCOUNT_MANAGER')(user.roles) ||
    and<EPermission>(routePermissions, 'PERMISSION_WRITE')(user.permissions);

  return <>{children(hasPermission)}</>;
});

export {PermissionCheck};
